import { Client } from "@bugsnag/browser";
import Home from "components/home";
import LicenseExpired from "components/licenseExpired";
import ErrorBoundary from "components/shared/errorBoundary";
import Login from "containers/login";
import { paths } from "helpers/paths";
import React, { lazy, Suspense } from "react";
import Loader from "components/shared/loader";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Store } from "redux";
import { confirmNavigation } from "services/navigationConfirmation";

const App = lazy(() => import(/* webpackChunkName: "app-shell" */ "containers/app"));

const Root = (props: { store: Store; bugsnagClient?: Client }) => {
    const { store, bugsnagClient } = props;

    if (location.pathname === paths.licenseExpired) {
        return <LicenseExpired />;
    }
    return (
        <ErrorBoundary>
            <Provider store={store}>
                <BrowserRouter getUserConfirmation={confirmNavigation}>
                    <Switch>
                        <Route path={paths.home} component={Home} />
                        <Login>
                            <Route
                                path="/"
                                render={(props) => (
                                    <Suspense fallback={<Loader />}>
                                        <App {...props} bugsnagClient={bugsnagClient} />
                                    </Suspense>
                                )}
                            />
                        </Login>
                    </Switch>
                </BrowserRouter>
            </Provider>
        </ErrorBoundary>
    );
};

export default Root;
